/* eslint-disable complexity */

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { ContentBlock, OneLinkProps } from "@/components/wpl/content-block/src";
import { Link } from "@/components/wpl/link/src";
import {
    TabGroup,
    IndividualTabPropsCustom,
    TabColorProps
} from "@/components/wpl/tab-group/src";
import {
    BGProps,
    ProductKeyTypes,
    StyledBackground,
    RowRevised
} from "@/libraries/wpl/foundations/src";

export interface PatternTabsCustomProps {
    id: string;
    label: string;
    headerText: string;
    bodyText: string;
    tabs: IndividualTabPropsCustom[];
    dataProductKey: ProductKeyTypes;
    colors?: TabColorProps;
    ctaProps?: OneLinkProps;
    linkPosition?: "top" | "bottom";
    backgroundProperties?: BGProps;
    className?: string;
}

const CustomTabsStyle = css({
    padding: `${token("space.800")} 0`,
    [media.only.sm]: {
        padding: `${token("space.600")} 0`
    },
    [media.below.sm]: {
        padding: `${token("space.400")} 0`
    }
});

export const TabsCustom = ({
    id,
    label,
    headerText,
    bodyText,
    tabs,
    dataProductKey,
    colors,
    ctaProps,
    linkPosition = "bottom",
    backgroundProperties,
    className
}: PatternTabsCustomProps) => {
    return (
        <StyledBackground {...backgroundProperties}>
            <div className={className} css={CustomTabsStyle}>
                {/*<Row layout="reduced">*/}
                <RowRevised>
                    <ContentBlock
                        headerText={headerText}
                        headerType="h2"
                        bodyText={bodyText}
                        isCentered={true}
                        ctaProps={
                            linkPosition == "top" && ctaProps?.primaryLinkProps
                                ? ctaProps
                                : {}
                        }
                    />
                </RowRevised>

                <div>
                    <TabGroup
                        colors={colors}
                        tabContentType="custom"
                        tabs={tabs}
                        id={id}
                        label={label}
                        dataProductKey={dataProductKey}
                    />
                </div>

                {linkPosition == "bottom" && ctaProps?.primaryLinkProps ? (
                    <RowRevised>
                        <div css={css({ textAlign: "center" })}>
                            <Link {...ctaProps.primaryLinkProps} />
                        </div>
                    </RowRevised>
                ) : null}
            </div>
        </StyledBackground>
    );
};
